"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZEmailSelectPrivate = void 0;
const types_1 = require("@daymade/common-lib/types");
const zod_1 = require("zod");
const zodSchemas_generated_1 = require("../generated/zodSchemas.generated");
exports.ZEmailSelectPrivate = zodSchemas_generated_1.zodSelectEmail
    .pick({
    id: true,
    playerId: true,
    state: true,
    templateName: true,
    templateData: true,
    unsubscribed: true,
})
    .extend((0, types_1.ensureSubsetOfKeys)(zodSchemas_generated_1.zodSelectEmail.shape, {
    createdAt: zod_1.z.coerce.date().nullable(),
    lastModified: zod_1.z.coerce.date().nullable(),
}));
//# sourceMappingURL=models.js.map